<section class="hero is-medium is-fullheight back-section1">
    <div class="hero-body">
        <div class="container has-text-centered">
            <p class="copytitle1">MINT NOW</p>
            <br />
            <a
                class="button is-rounded buttoncopyhover"
                href="https://mint.internationalbrigadeofkyiv.com"
                target="blank">MINT NOW</a
            >
            <div class="columns is-mobile is-centered has-text-left is-copy">
                <div class="column is-10">
                    <p class="subtitle copy1 italic mt-5">
                        "Prove that you are standing with us, We have proved our
                        strength. Prove that you are with us. Prove that you do
                        not let us go. And then life will win over death, and
                        light will win over darkness"
                    </p>
                    <p class="subtitle copy1 italic has-text-right mb-5">
                        Volodymyr Zelenskyy, President of Ukraine
                    </p>
                    <br />
                    <p class="subtitle copy1 mt-5">
                        Ukraine is under a brutal and unjustified attack from
                        Vladimir Putin’s Russia and we are trying to do our
                        small part by raising funds with IBOK (International
                        Brigade Of Kyiv). After spending the last 6 months
                        developing our debut NFT project, the invasion inspired
                        us to rework the art and utility and instead dedicate
                        the collection to assisting the Ukrainian people. The
                        destruction of the country by Putin’s army and the
                        targeting of civilians, hospitals and food supplies
                        makes us sick to our stomach. Equally, the bravery of
                        the Ukrainians inspires us and if they don’t deserve our
                        help, who does?
                        <br /><br />
                        The proceeds from the mint for IBOK will be directed at contract
                        level to the
                        <a
                            class="link"
                            href="https://donate.thedigital.gov.ua/"
                            target="blank"
                            >official Ukrainian Government Ethereum address</a
                        >. Given that both the invasion and cyber attacks pose
                        considerable risks to the Ukrainian banking system, this
                        is an opportunity for crypto to make a real difference,
                        to be the utopian version of crypto which strips red
                        tape and bureaucracy to generate a positive impact in
                        the world. So far, around 100m of crypto has been
                        donated by the community, you can read more about it
                        <a
                            class="link"
                            href="https://dune.xyz/msilb7/Ukraine-Crypto-Donations"
                            target="blank">here</a
                        >.<br />
                        If we sell through the entire collection, we will raise around
                        200 ETH or around half a million US dollar from the mint
                        at the price at 18.03.21. Plus we are applying a high 10%
                        royalty on
                        <a
                            class="link"
                            href="https://opensea.io/collection/ibok"
                            target="blank">Opensea</a
                        >
                        to generate a continuing donation stream to Ukraine.
                        <br /><br />
                        You are welcome to set your NFT as your avatar to show solidarity.
                        You also retain full commercial rights. You can do what you
                        want with your NFT, just don’t be an asshole and use it for
                        Russian propaganda, racism, homophobia, extremism on the
                        left or the right or any fascist bullshit.
                    </p>
                    <p class="title copy1 has-text-centered mt-2">
                        Mint Price : 0.02 ETH <br />
                        Supply: 10150
                    </p>
                    <div class="has-text-centered">
                        <a
                            class="button is-rounded buttoncopyhover"
                            href="https://mint.internationalbrigadeofkyiv.com"
                            target="blank">MINT NOW</a
                        >
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
